module.exports = __webpack_public_path__ + "static/media/galeria-fotos-7-big.ba782174.jpg";